import axiosInstance from './axiosInstance';
import config from '../config.json';

export async function sendAnalyticsEvent({ courseDispatchId, type, tool, actorId, objectId, objectType, duration, metadata, timestamp, useBeacon = false }) {
  try {
    const body = {
      course_dispatch_id: courseDispatchId,
      type,
      tool: tool || null,
      actor_id: actorId || null,
      object_id: objectId || null,
      object_type: objectType || null,
      duration: duration || null,
      metadata: metadata || null,
      timestamp: timestamp || new Date().toISOString()
    };
    
    // 如果使用 keepalive（頁面關閉時），使用 fetch with keepalive 確保事件發送
    if (useBeacon) {
      const url = `${window.location.origin}/api/analytics/events`;
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      
      try {
        // 使用 fetch with keepalive（在頁面關閉時也能發送，支持 headers）
        // keepalive 確保即使頁面關閉，請求也會完成
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
          },
          body: JSON.stringify(body),
          keepalive: true // 確保在頁面關閉時也能發送
        });
        if (response.ok) {
          return { data: { success: true } };
        }
      } catch (fetchError) {
        // fetch 失敗時靜默處理，避免影響用戶體驗
        // 注意：在頁面關閉時，即使 fetch 失敗，也無法再發送請求
      }
    }
    
    // 正常情況使用 axios
    return await axiosInstance.post('api/analytics/events', body);
  } catch (e) {
    // 靜默失敗，避免影響主流程
    // console.warn('[analytics] send failed', e);
    return null;
  }
}


